import { NgModule } from "@angular/core";
import * as ngCommon from "@angular/common";
import { FormsModule } from "@angular/forms";
import { HttpModule, JsonpModule } from "@angular/http";
import { HttpClientModule } from "@angular/common/http";
import { ModalModule, TooltipModule, TabsModule } from "ngx-bootstrap";
import { FileUploadModule } from "@node_modules/ng2-file-upload";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./shared/layout/header.component";
import { HeaderNotificationsComponent } from "./shared/layout/notifications/header-notifications.component";
import { SideBarMenuComponent } from "./shared/layout/nav/side-bar-menu.component";
import { PageSearchComponent } from "./shared/layout/page-search/page-search.component";
import { TopBarMenuComponent } from "./shared/layout/nav/top-bar-menu.component";
import { FooterComponent } from "./shared/layout/footer.component";
import { LoginAttemptsModalComponent } from "@app/shared/layout/login-attempts-modal.component";
import { ChangePasswordModalComponent } from "@app/shared/layout/profile/change-password-modal.component";
import { ChangeProfilePictureModalComponent } from "@app/shared/layout/profile/change-profile-picture-modal.component";
import { MySettingsModalComponent } from "@app/shared/layout/profile/my-settings-modal.component";
import { SmsVerificationModalComponent } from "@app/shared/layout/profile/sms-verification-modal.component";
import { AbpModule } from "@abp/abp.module";
import { UtilsModule } from "@shared/utils/utils.module";
import { AppCommonModule } from "./shared/common/app-common.module";
import { ServiceProxyModule } from "@shared/service-proxies/service-proxy.module";
import { ImpersonationService } from "./admin/users/impersonation.service";
import { LinkedAccountService } from "./shared/layout/linked-account.service";
import { LinkedAccountsModalComponent } from "@app/shared/layout/linked-accounts-modal.component";
import { LinkAccountModalComponent } from "@app/shared/layout/link-account-modal.component";
import { NotificationsComponent } from "./shared/layout/notifications/notifications.component";
import { NotificationSettingsModalComponent } from "./shared/layout/notifications/notification-settings-modal.component";
import { UserNotificationHelper } from "./shared/layout/notifications/UserNotificationHelper";
import { ChatBarComponent } from "./shared/layout/chat/chat-bar.component";
import { ChatFriendListItemComponent } from "./shared/layout/chat/chat-friend-list-item.component";
import { ChatSignalrService } from "@app/shared/layout/chat/chat-signalr.service";
import { QuickSideBarChat } from "@app/shared/layout/chat/QuickSideBarChat";
import { DataTableModule } from "primeng/primeng";
import { PaginatorModule } from "primeng/primeng";
import {
    FileUploadModule as PrimeNgFileUploadModule,
    ProgressBarModule,
} from "primeng/primeng";
import { ChatMessageComponent } from "./shared/layout/chat/chat-message.component";
import { NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap";

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        HeaderNotificationsComponent,
        SideBarMenuComponent,
        PageSearchComponent,
        TopBarMenuComponent,
        FooterComponent,
        LoginAttemptsModalComponent,
        LinkedAccountsModalComponent,
        LinkAccountModalComponent,
        ChangePasswordModalComponent,
        ChangeProfilePictureModalComponent,
        MySettingsModalComponent,
        SmsVerificationModalComponent,
        NotificationsComponent,
        ChatBarComponent,
        ChatFriendListItemComponent,
        NotificationSettingsModalComponent,
        ChatMessageComponent,
    ],
    imports: [
        NgbPaginationModule.forRoot(),
        HttpClientModule,
        ngCommon.CommonModule,
        FormsModule,
        HttpModule,
        JsonpModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        TabsModule.forRoot(),
        FileUploadModule,
        AbpModule,
        AppRoutingModule,
        UtilsModule,
        AppCommonModule.forRoot(),
        ServiceProxyModule,
        DataTableModule,
        PaginatorModule,
        PrimeNgFileUploadModule,
        ProgressBarModule,
    ],
    providers: [
        ImpersonationService,
        LinkedAccountService,
        UserNotificationHelper,
        ChatSignalrService,
        QuickSideBarChat,
    ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts